import "./About.scss";
import tazeen from "../../assets/tazeen.png";
import alyssia from "../../assets/alyssia.png";

const About = () => {
  return (
    <div className="about">
      <div className="content">
        <h1>About Us</h1>
        <div className="about-section">
          <div className="photo-card">
            <h2>Tazeen Hemraj</h2>
            <img src={tazeen} alt="Tazeen Hemraj" />
          </div>
          <div className="bio">
            <p>
              Hey! My name is Tazeen and I'm a second-year Honours Integrated
              Science student at McMaster University. I'm deeply interested in
              the expanding role of AI in sustainability, especially in
              transforming sustainable agriculture. I am also passionate about
              advocating for interdisciplinary initiatives that tackle climate
              issues and have applied this in local projects, like the "Play the
              Way" initiative in Hamilton, aimed at reducing greenhouse gas
              emissions through promoting active travel. As a Community Advisor
              at McMaster, I lead educational programs to enhance the social
              experience of residents and engage in pedagogical discussions with
              staff to optimize educational outcomes for residents. Currently,
              as a member of McMaster's Synthetic Biology Team, I'm involved in
              designing a protein chassis that utilizes microalgae for the
              sustainable production of biofuels. In my free time, I enjoy
              reading, painting, and sewing. Feel free to get in touch if you
              have any questions or just want to talk!
            </p>
          </div>
        </div>
        <div className="about-section">
          <div className="photo-card">
            <h2>Alyssia Naran</h2>
            <img src={alyssia} alt="Alyssia Naran" />
          </div>
          <div className="bio">
            <p>
              Hey! My name's Alyssia and I'm in my second year of Honours
              Integrated Science at McMaster University. I'm super passionate
              about the intersection of AI and healthcare and I look forward to
              seeing and contributing to future innovations in this field. I
              have worked on a few AI projects including detecting COVID-19 from
              lung CT-Scan images and detecting Alzheimer's from brain MRI
              scans. Last summer, I worked at the Hospital for Sick Children
              where I used machine learning to summarize injury and mental
              health patient cases from the emergency department. Currently, I
              am the VP of Events for the Artificial Intelligence in Medicine
              Student Society at McMaster. Additionally, I'm collaborating with
              Borealis AI on a project that leverages liver transplant data to
              develop a predictive model for post-transplant mortality. In my
              free time, I like going to the gym, reading, and cooking. Feel
              free to reach out if you have any questions or if you’d like to
              chat about anything at all :)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
